import React, { Component } from 'react';

class Step5 extends Component {
  render () {
    return (
      <div className='registration__first'>
        <div className='registration__inner'>
          <h1 className='kilo'>Thank you for signing up, click the button below to start your course</h1>
          <div className='registration__cta'>
            <a onClick={() => this.props.handleNextClick()} className='registration__start registration__next button button--xl button--shadow button--full'>Start your course now</a>
          </div>
        </div>
      </div>
    );
  }
}

export default Step5;



// WEBPACK FOOTER //
// ./src/components/CoursePicker/Step5/index.js